module.exports = __webpack_public_path__ + "img/check.5ec4b741.png";